import { Component, OnInit, ViewChild } from '@angular/core';
import { APICallerService, OcInfraModule, OptionParams,Configuration, ResourceService } from '@diaas/ux-web';
import * as _ from 'lodash';
import { CommonService, retryOperation } from '../../services/common.service';
import { AdvGrowlService } from 'primeng-advanced-growl';



@Component({
  selector: 'app-role-confirmation-notice',
  templateUrl: './role-confirmation-notice.component.html',
  styleUrls: ['./role-confirmation-notice.component.scss']
})
export class RoleConfirmationNoticeComponent implements OnInit {
 addUpdateFormObj:any = {};
 addressProperties: any;
 ownerDetails:any;
 addressPostalCode: any;
 resourceService = OcInfraModule.AppInjector.get(ResourceService);
 disableSave : boolean= true;
 emailIdCheckbox: boolean = false;
 disableEmailInput: boolean = false;
 emailAddress: string = '';
 emailAddressChecked: boolean = false;
 beneChangeForm:any;
 formType: any;
 header:any;
 ownerChangeInd:boolean = false;
 disableAllForm:boolean = false;
 isEmailAddressValid: boolean = false;
 hoverMessage: string = 'When this button is pressed, it sends print command to the system';
  constructor( public commonService: CommonService) {}

    ngOnInit() {
      const headers = OcInfraModule.AppInjector.get(CommonService).getHeaderByAliasName("partyRoles");
      let roleList = this.resourceService.getResourceFromAliasName('partyRoles');
      let selectRoleSummary = _.filter(roleList._links.item, function (o) { return o.summary.role_name == 'OWN' });
      if(selectRoleSummary.length > 0){
      OcInfraModule.AppInjector.get(CommonService).getCallback(selectRoleSummary[0].href, headers).subscribe(partyResponse => {
         let infoUrl = partyResponse._links.hasOwnProperty('person') ? partyResponse._links.person.href : partyResponse._links.organization.href;
          OcInfraModule.AppInjector.get(CommonService).partyResponse = partyResponse;
          OcInfraModule.AppInjector.get(CommonService).getCallback(infoUrl, headers).subscribe(response => {
              let personResponse = response;
              this.ownerDetails = response;
              OcInfraModule.AppInjector.get(CommonService).emailHref = personResponse._links["email"].href;
              OcInfraModule.AppInjector.get(CommonService).getCallback(personResponse._links["address"].href, headers).subscribe(addressResponse => {
              this.addUpdateFormObj = addressResponse._embedded.addressList[0];            
              this.addressProperties = addressResponse._options.properties;
              this.addUpdateFormObj.first_name =this.ownerDetails.first_name;
              this.addUpdateFormObj.last_name =this.ownerDetails.last_name;
              this.addUpdateFormObj.zip4 == '' ? this.addUpdateFormObj.zip4 ='0000': this.addUpdateFormObj.zip4;
              this.addressProperties.country.oneOf.filter(e => {
                  e.enum[0] == this.addUpdateFormObj.country ? this.addUpdateFormObj.country_desc = e.title : '';
                });
                this.addressProperties.state.oneOf.filter(e => {
                  e.enum[0] == this.addUpdateFormObj.state ? this.addUpdateFormObj.state_desc = e.title : '';
                });
            });
          });
        });
     
       }
    }


  filteredStates() {
    return this.addressProperties.state.oneOf.filter(state => state.enum && state.title.trim() !== '');
  }
    

  formatPostalCode(e){
    if (e.keyCode > 31 && ((e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) && e.keyCode != 46) {
      e.preventDefault();
    } else {
        this.addUpdateFormObj.zip4 = e.target["value"].replace(/[^0-9]*/g, '');
    }
  }

   onEmailPaste(e, email){
      e.target.value = email;
      this.addEmailAddress(e);
   }

   addEmailAddress(e) {
      this.isEmailAddressValid = false;
      if(e.target.value.length){
         if( e.target.value.trim() != '' &&  e.target.value.trim() >5 ||
            /^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25}(($)|( *;+ *$)|( *;+ *(?=[a-zA-Z0-9_\-\.]))))*$/.test(e.target.value.trim())){
            this.isEmailAddressValid = true;
         }
      }  
       this.enableDisableSend();          
   }


   formatPostalOnPaste(e){
    this.formatValidPostalCode(e);
    this.formatPostalCode(e)
  }

  formatValidPostalCode(e){
    e.target["value"] = e.target["value"].replace(/[^0-9]*/g, '');
    this.enableDisableSend();
  }

  enableDisableSend(){
    if(((this.emailAddressChecked && (this.emailAddress =='' || this.isEmailAddressValid == false))|| (this.addUpdateFormObj.zip4.length < 4 || this.addUpdateFormObj.zip4 =='') || this.formType == '' || (this.beneChangeForm =='' && this.disableAllForm == false ))){
      this.disableSave = true;
    }else{
      this.disableSave= false;
    }
  }

   // On click on email
   emailIdCheckboxChecked(e) {
      this.emailIdCheckbox = e.checked;
      if(e.checked){
        this.header = OcInfraModule.AppInjector.get(CommonService).getHeaderByAliasName("partyRoles");
         OcInfraModule.AppInjector.get(CommonService).getCallback(OcInfraModule.AppInjector.get(CommonService).emailHref, this.header).subscribe(refreshResponse => {
          if(refreshResponse._embedded.communicationNumberList && refreshResponse._embedded.communicationNumberList.length > 0){
             this.emailAddress = refreshResponse._embedded.communicationNumberList[refreshResponse._embedded.communicationNumberList.length-1].number;
             this.disableEmailInput = true;
             this.isEmailAddressValid = true;
            }else{
              this.disableEmailInput = false;
              this.disableSave= true;
             }
          });
      }else{
        this.emailAddressChecked = false;
        this.emailAddress ='';
         this.enableDisableSend();          
      }    
   }


  onFormChange(value){
    if(value == 'Y'){
      this.beneChangeForm ='L';
      this.disableAllForm = false;
     }else{
       this.beneChangeForm ='';
       this.disableAllForm = true;
     }
    this.enableDisableSend();
  }

  sendConfirmation(){
    let policyDetails = OcInfraModule.AppInjector.get(ResourceService).getResourceFromAliasName('policyDetails');
    let beneOwnEmail = policyDetails._links["/beneowneremail"].href ;
     let header = _.filter(Configuration.config.headers["multiHostUrlHeader"], function (o) { return o.alias == 'beneOwnerChange' });
     header[0].headers['role'] = OcInfraModule.AppInjector.get(CommonService).selectedRole;
     header[0].headers['product_type'] = policyDetails.data.product_type;
     header[0].headers['user_role'] = OcInfraModule.AppInjector.get(CommonService).userRole.toUpperCase();
    delete header[0]['headers']['role_name'];
     let payload ={
      "name":this.ownerDetails.full_name,      
      "policyNumber":policyDetails.data.policy_number,
      "country_desc":this.addUpdateFormObj.country_desc,
      "country":this.addUpdateFormObj.country,
      "city":this.addUpdateFormObj.city,
      "address_id":this.addUpdateFormObj.address_id,
      "zip4":this.addUpdateFormObj.zip4,
      "zip5":this.addUpdateFormObj.zip5,
      "address_type_desc":this.addUpdateFormObj.address_type_desc,
      "address_line1":this.addUpdateFormObj.address_line1,
      "address_line2":this.addUpdateFormObj.address_line2,
      "address_line3":this.addUpdateFormObj.address_line3,
      "address_line4":this.addUpdateFormObj.address_line4,
      "state_desc":this.addUpdateFormObj.state_desc,
      "state":this.addUpdateFormObj.state,
      "emailInd":this.emailAddressChecked,
      "emailId":this.emailAddress,
      "formInd":this.formType,
      "beneFormInd":this.beneChangeForm,
      "ownerChangeInd":this.ownerChangeInd
    }
      OcInfraModule.AppInjector.get(CommonService).postCallback(beneOwnEmail, payload, header[0].headers).subscribe(response => {
         OcInfraModule.AppInjector.get(AdvGrowlService).createSuccessMessage('SUCCESS Print letter has been generated', 'Success');
         const workRequestHref = OcInfraModule.AppInjector.get(ResourceService).getHrefByAliasName("workRequestHistory").split('?')[0];
          let workRequestheaders = _.filter(Configuration.config.headers["multiHostUrlHeader"], function (o) { return o.alias == 'workRequestHistory' });
          setTimeout(() => {
          document.getElementById("modal__cross").click();    
          }, 300);      
          if (response.success) {
          setTimeout(() =>{
              OcInfraModule.AppInjector.get(APICallerService).refresh(workRequestHref, { 'alias': "workRequestHistory", 'headers': workRequestheaders[0].headers}).subscribe(refreshResponse => {
              OcInfraModule.AppInjector.get(CommonService).wrkReqHistoryRes = refreshResponse;
              OcInfraModule.AppInjector.get(CommonService).sendFilterEvent();
            });
          },500); 
         }   
        }, error => {
             if (error && error._embedded && error._embedded.status_report && error._embedded.status_report.consistent === false) {
             OcInfraModule.AppInjector.get(AdvGrowlService).createTimedErrorMessage(error._embedded.status_report.messages[0].message, 'Error', 0);
             } else {
               OcInfraModule.AppInjector.get(AdvGrowlService).createTimedErrorMessage("Something went wrong please try again", 'Error', 0);
             }
      });

  }

}